// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__200b-","label":"SetPasswdForm_label__2S3Xf"};